/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionRadioOff: {
  name: 'temp-selection-radio-off';
  data: string;
} = {
  name: 'temp-selection-radio-off',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z" fill="currentColor"/></svg>`,
};
